/**
 * @file Re-exports the investment tiers checkbox and amount input.
 */
import InvestmentsInput from "./InvestmentsInput";

export default InvestmentsInput;
